import { render, staticRenderFns } from "./ManuscriptRewriting.vue?vue&type=template&id=4d0d24fd&scoped=true"
import script from "./ManuscriptRewriting.vue?vue&type=script&lang=js"
export * from "./ManuscriptRewriting.vue?vue&type=script&lang=js"
import style0 from "./ManuscriptRewriting.vue?vue&type=style&index=0&id=4d0d24fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d24fd",
  null
  
)

export default component.exports